import { useState } from 'react'

type HookProps = {
  onVideoEnd: () => void
}

const useVideoEnd = ({ onVideoEnd }: HookProps) => {
  const [isEnded, setIsEnded] = useState(false)

  const handleVideoEnd = () => {
    setIsEnded(true)
    onVideoEnd()
  }

  const resetEnded = () => setIsEnded(false)

  return [isEnded, resetEnded, handleVideoEnd] as const
}

export default useVideoEnd
